export default {
  // 按钮
  add: '新增',
  edit: '编辑',
  delete: '删除',
  confirm: '确定',
  cancel: '取消',

  // 表格列标题
  menuName: '菜单名称',
  icon: '图标',
  order: '排序',
  routeName: '路由名称',
  componentPath: '组件路径',
  routePath: '路由路径',
  status: '状态',
  createTime: '创建时间',
  action: '操作',

  // 表单标签
  parentMenu: '上级菜单',
  menuType: '菜单类型',
  menuIcon: '菜单图标',
  menuNameLabel: '菜单名称',
  routeAddress: '路由地址',
  componentName: '组件名称',
  componentPathLabel: '组件路径',
  displayOrder: '显示排序',
  isExternalLink: '是否外链',
  permissionChar: '权限字符',
  usageType: '使用类型',
  isVisible: '是否显示',

  // 占位符
  selectParentMenu: '请选择上级菜单',
  fillOrder: '填写排序',

  // 状态
  normal: '正常',

  // 弹窗标题
  addMenu: '新增菜单',
  editMenu: '修改菜单',

  // 确认对话框
  deleteConfirm: '是否删除',

  // 成功消息
  deleteSuccess: '删除成功',
  editSuccess: '修改成功',
  addSuccess: '新增成功',

  // 验证消息
  parentMenuRequired: '上级菜单不能为空',
  menuOrderRequired: '菜单顺序不能为空',
  routeAddressRequired: '路由地址不能为空',
  componentAddressRequired: '组件地址不能为空',
  menuNameRequired: '请输入菜单名称',

  // 树节点
  mainCategory: '主类目',

  // 通用选项
  yes: '是',
  no: '否',
}
